export default "__VITE_ASSET__C7Kg1FO$__"